var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.002,
    height: 100.999,
    viewBox: "0 0 101.002 100.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Distributor_master",
    "data-name": "Distributor master",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24101",
    "data-name": "Path 24101",
    d: "M105.015,55a6.772,6.772,0,0,0-6.635,5.367H89.3a27.409,27.409,0,0,0-7.143-17.072l6.438-6.427A6.738,6.738,0,1,0,86.6,34.818L80.119,41.3a27.434,27.434,0,0,0-17.1-6.973V25.239a6.776,6.776,0,1,0-2.866-.088v9.2a27.441,27.441,0,0,0-16.876,7.117l-6.433-6.433a6.774,6.774,0,1,0-2.072,1.982l6.488,6.465a27.382,27.382,0,0,0-6.985,17.09H25.241A6.868,6.868,0,0,0,18.568,55a6.775,6.775,0,1,0,0,13.551,6.648,6.648,0,0,0,6.567-5.112H34.3A27.282,27.282,0,0,0,41.384,80.3l-6.4,6.407a6.828,6.828,0,1,0,1.995,2.071l6.434-6.434A27.436,27.436,0,0,0,60.358,89.35V98.4a6.778,6.778,0,1,0,2.866,0V89.35a27.44,27.44,0,0,0,17.061-7.113l6.4,6.4a6.781,6.781,0,1,0,2.045-2.009l-6.426-6.45A27.339,27.339,0,0,0,89.3,63.231h9.1A6.775,6.775,0,1,0,105.014,55ZM89.589,28.468A3.912,3.912,0,0,1,95.121,34h0a3.912,3.912,0,1,1-5.532-5.532ZM33.994,34a3.912,3.912,0,1,1,0-5.532h0A3.91,3.91,0,0,1,33.994,34ZM18.568,65.709A3.912,3.912,0,1,1,22.48,61.8a3.912,3.912,0,0,1-3.912,3.912ZM33.994,95.127a3.912,3.912,0,0,1-5.532-5.532h0a3.9,3.9,0,0,1,5.381-.137,1.405,1.405,0,0,0,.4.409,3.91,3.91,0,0,1-.247,5.259Zm55.595-5.532a3.912,3.912,0,1,1,0,5.532h0A3.91,3.91,0,0,1,89.589,89.595ZM57.88,18.574a3.912,3.912,0,1,1,3.912,3.912A3.912,3.912,0,0,1,57.88,18.574ZM65.7,105.02a3.912,3.912,0,1,1-4.2-3.9,1.442,1.442,0,0,0,.576,0A3.914,3.914,0,0,1,65.7,105.02Zm-3.912-18.5A24.679,24.679,0,1,1,86.47,61.842,24.679,24.679,0,0,1,61.791,86.521Zm43.223-20.812a3.912,3.912,0,1,1,3.912-3.912A3.912,3.912,0,0,1,105.015,65.709Z",
    transform: "translate(-11.793 -11.8)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24102",
    "data-name": "Path 24102",
    d: "M192.766,163.193l-11.151-6.438a.976.976,0,0,0-.976,0l-11.151,6.438a.976.976,0,0,0-.488.845v12.876a.976.976,0,0,0,.488.845l11.151,6.438a.976.976,0,0,0,.976,0l11.151-6.438a.976.976,0,0,0,.488-.845V164.038a.976.976,0,0,0-.488-.845Zm-11.639-4.466,3.514,2.029-9.2,5.311-3.514-2.029Zm-.976,22.935-9.2-5.311V165.727l9.2,5.311Zm.976-12.314-3.734-2.155,9.2-5.311,3.734,2.155Zm10.175,7-9.2,5.311V171.038l9.2-5.311Z",
    transform: "translate(-131.128 -120.479)",
    fill: "#005795",
    stroke: "#005795",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorMaster);
export default __webpack_public_path__ + "static/media/distributorMaster.fe64ae3038fd0035c8198a62fe3d52ab.svg";
export { ForwardRef as ReactComponent };